import React from 'react';
import { Navigate } from 'react-router-dom';

export default function ProtectedRoute({ children, user, rolRequerido }) {
  if (!user) {
    return <Navigate to="/login" replace />;
  }

  if (rolRequerido && user.rol !== rolRequerido) {
    return <Navigate to="/" replace />;
  }

  return children;
}